<template>
    <div class="s-que">
        <manage-title>公共题库</manage-title>
        <!-- 筛选条件 -->
        <div class="s-condition xy-between flex-wrap">
            <div class="xy-center jf-start item">
                <div class="name">科目</div>
                <el-cascader
                    ref="cascader"
                    placeholder="请输入科目关键字检索..."
                    :props="categoryProps"
                    :options="categoryInfo"
                    :filter-method="dataFilter"
                    filterable
                    clearable
                    v-model="selectColum"
                    @change="CategoryChange"
                    style="width:350px"
                >
                    <template v-slot="{node, data}">
                        <span @click="clickCategory(node, data)">{{ data.text }}</span>
                    </template>
                </el-cascader>
            </div>
            <div class="xy-center jf-start item">
                <div class="name">题型</div>
                <el-select
                    v-model="selectQuestionType"
                    placeholder="请选择题型"
                    @change="GetPulicQuestionInfo(true)"
                >
                    <el-option
                        v-for="item in questionTypeData"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                    >
                    </el-option>
                </el-select>
            </div>
            <div class="xy-start search item">
                <el-input
                    v-model="searchKey"
                    placeholder="请输入关键字检索..."
                    style="margin-right: -5px"
                    @keyup.enter.native="GetPulicQuestionInfo(true)"
                ></el-input>
                <el-button
                    type="primary"
                    icon="el-icon-search"
                    style="z-index: 10"
                    @click="GetPulicQuestionInfo(true)"
                    >检索</el-button
                >
            </div>
        </div>
        <div class="jf-end s-options">
            <el-button type="success" plain size="mini" @click="OpenCopyDialog"
                >批量复制</el-button
            >
        </div>

        <div style="padding: 0 30px">
            <el-table
                v-loading="loading"
                :data="data"
                ref="table"
                row-key="id"
                border
                class="el-table"
                @selection-change="GetSelectValue"
            >
                <el-table-column type="selection" width="50" align="center">
                </el-table-column>
                <el-table-column
                    label="序号"
                    type="index"
                    width="50"
                    align="center"
                >
                </el-table-column>
                <el-table-column prop="stem" label="试题">
                    <template v-slot="scope">
                        <div v-html="scope.row.question"></div>
                    </template>
                </el-table-column>

                <el-table-column
                    prop="categoryName"
                    label="科目"
                    align="center"
                    width="150"
                >
                </el-table-column>

                <!-- <el-table-column
                    prop="typeName"
                    label="题型"
                    align="center"
                    width="100"
                >
                </el-table-column> -->

                <el-table-column
                    prop="UpdateTime"
                    label="更新时间"
                    align="center"
                    width="100"
                    :formatter="cdateFormatter"
                >
                </el-table-column>

                <el-table-column
                    label="操作"
                    width="70"
                    align="center"
                    class-name="options-btn"
                >
                    <template v-slot="scoped">
                        <el-button
                            size="mini"
                            type="success"
                            @click="
                                OpenCopyDialogSingle(scoped.$index, scoped.row)
                            "
                            plain
                            >复制
                        </el-button>
                    </template></el-table-column
                ></el-table
            >
        </div>

        <div class="pagination xy-center mt-17">
            <el-pagination
                :background="true"
                :current-page.sync="pageIndex"
                :page-size.sync="pageSize"
                :total="total"
                layout="total, sizes, prev, pager, next, jumper"
                @current-change="PageChange"
                hide-on-single-page
                @size-change="SizeChange"
            >
            </el-pagination>
        </div>

        <el-dialog
            title="复制试题"
            :visible.sync="copyDialog"
            :lock-scroll="false"
            custom-class="m-dialog"
            width="500px"
        >
            <el-form
                ref=""
                size="medium"
                label-width="50px"
                style="padding:20px 0"
            >
                <el-form-item>
                    <el-col :span="4">所属分类</el-col>
                    <el-col :span="16">
                        <medical-class-selector
                            v-model.number="questionType"
                            :add-all="false"
                            style="width:280px"
                        ></medical-class-selector>
                    </el-col>
                </el-form-item>
                <el-form-item style="padding-top:20px">
                    <el-col :span="4">试题用途</el-col>
                    <el-col :span="16">
                        <el-select
                            v-model.number="questionUseValue"
                            clearable
                            style="width:280px"
                        >
                            <el-option
                                v-for="item in questionUse"
                                :key="item.value"
                                :label="item.name"
                                :value="item.value"
                            >
                            </el-option>
                        </el-select>
                    </el-col>
                </el-form-item>
            </el-form>

            <div slot="footer" class="dialog-footer">
                <el-button size="medium" @click="closeCopyDialog"
                    >取 消</el-button
                >
                <el-button size="medium" type="primary" @click="Copy"
                    >复 制</el-button
                >
            </div>
        </el-dialog>
    </div>
</template>

<script>
import { GetSystemCategoryInfo } from "@/api/course";
import {
    GetPulicQuestionInfo,
    ImportPulicQuestionToOrgan
} from "@/api/questionPaper";
import MedicalClassSelector from "@/components/manager/MedicalClassSelector";
import ManageTitle from "@/components/manager/ManageTitle";
import { isEmpty } from "lodash";
import { alphabet, removeEmptyChildren } from "@/utils";
import { PmStateMixin } from "@/mixins/reqState";

export default {
    components: { ManageTitle, MedicalClassSelector },
    mixins: [PmStateMixin],
    data() {
        return {
            categoryProps: {
                value: "id",
                label: "name",
                children: "children",
                expandTrigger: "hover",
                checkStrictly: true,
                clearable: true,
                "show-all-levels": true
            },
            categoryInfo: [],
            selectColum: [],
            selectName: "",
            questionTypeData: [
                {
                    value: "-1",
                    label: "全部"
                },
                {
                    value: "1",
                    label: "单选题"
                },
                {
                    value: "2",
                    label: "多选题"
                },
                {
                    value: "3",
                    label: "填空题"
                },
                {
                    value: "4",
                    label: "判断题"
                },
                {
                    value: "5",
                    label: "简答题"
                },
            ],
            selectQuestionType: null,
            searchKey: "",
            data: [],
            total: 0,
            pageIndex: 1,
            pageSize: 10,
            copyDialog: false,
            // 试题用途
            questionUse: [
                {
                    value: 1,
                    name: "考试"
                },
                {
                    value: 2,
                    name: "作业"
                },
                {
                    value: 3,
                    name: "前台练习"
                }
            ],
            questionUseValue: 1,
            questionType: null,
            questionIdstr: "",
            loading: false
        };
    },
    watch: {},
    mounted() {},
    created() {
        this.GetSystemCategoryInfo();
        this.questionUseValue = this.questionUse[0].value;
    },
    methods: {
        // 获取科目
        async GetSystemCategoryInfo() {
            try {
                const { data } = await GetSystemCategoryInfo();
                removeEmptyChildren(data.data, "children")
                this.categoryInfo = data.data;
            } catch (err) {
                this.$message("获取科目发生异常！", "error");
            }
        },
        CategoryChange(val) {
            this.$nextTick(() => {
                this.selectName = "";
                let labelArr = this.$refs.cascader.getCheckedNodes()[0].pathLabels;
                labelArr.forEach((item, i) => {
                    if (i === labelArr.length - 1) {
                        this.selectName += item;
                    } else {
                        this.selectName += item + " ＞ ";
                    }
                });
                this.GetPulicQuestionInfo(true);
            })
        },
        clickCategory(node, data) {
            this.selectColum = node.path;
            this.CategoryChange()
        },
        // 科目过滤
        dataFilter(node, val) {
            if (
                !!~node.text.indexOf(val) ||
                !!~node.text.toUpperCase().indexOf(val.toUpperCase())
            ) {
                return true;
            }
        },
        // 获取公共题库
        async GetPulicQuestionInfo(refresh) {
            if (refresh === true) {
                this.pageIndex = 1;
            }

            if (!this.selectColum) {
                return;
            }

            try {
                const { data } = await this.wrapPromising(GetPulicQuestionInfo({
                    pageIndex: this.pageIndex,
                    pageSize: this.pageSize,
                    sortBy: "crt_date",
                    sortOrder: "desc",
                    keyWord: this.searchKey,
                    category: this.selectColum[this.selectColum.length - 1],
                    questionType: this.selectQuestionType
                }));
                this.data = data.data;
                this.total = data.count;

                this.data.forEach((item, i) => {
                    var typeName = "";
                    if (item.SubjectType === 1) {
                        typeName = "单选题";
                    } else if (item.SubjectType === 2) {
                        typeName = "多选题";
                    } else if (item.SubjectType === 3) {
                        typeName = "填空题";
                    } else if (item.SubjectType === 4) {
                        typeName = "判断题";
                    } else if (item.SubjectType === 5) {
                        typeName = "问答题";
                    } else {
                        typeName = "其它";
                    }

                    item.categoryName = this.selectName;

                    item.question =
                        "<b>【" +
                        typeName +
                        "</b>】" +
                        item.SubjectName +
                        "<br />";
                    let plans = {
                        1: this.selectQuestionJoin,
                        2: this.selectQuestionJoin,
                        4: this.selectQuestionJoin,
                        3: this.fillQuestionJoin,
                        5: this.answerQuestionJoin
                    }
                    item.question = plans[item.SubjectType].call(this, item.question, item)
                    item.question += "<br />【解析】" + item.Analysis;
                });
            } catch (err) {
                this.$toast("获取失败");
            }
        },
        // 选择题拼接
        selectQuestionJoin(questionStr, item) {
            let optionStr = "";
            let rightAnswer = "";
            item.AnswerList.forEach((answer, j) => {
                optionStr += `【${alphabet[answer.RankNum]}】${answer.Content}<br />`
                if (answer.IsRight === 1) {
                    rightAnswer += alphabet[answer.RankNum]
                }
            })
            questionStr += optionStr;
            questionStr += "【答案】" + rightAnswer;
            return questionStr
        },
        // 填空题拼接
        fillQuestionJoin(questionStr, item) {
            let optionStr = "";
            item.AnswerList.forEach((answer, j) => {
                optionStr += `【答案${j + 1}】${answer.Content}<br />`
            })
            questionStr += optionStr;
            return questionStr
        },
        // 回答题拼接
        answerQuestionJoin(questionStr, item) {
            questionStr += "【答案】" + item.AnswerList[0].Content
            return questionStr
        },
        // 更新时间列列格式化
        cdateFormatter(row, col) {
            if (row.UpdateTime) {
                return row.UpdateTime.substring(0, 10);
            } else {
                return "";
            }
        },
        GetSelectValue(val) {
            this.questionIdstr = "";
            this.questionIdstr = val.map(item => item.SubjectId).join(",")
        },
        OpenCopyDialog() {
            if (!this.questionIdstr || this.questionIdstr.length === 0) {
                this.$message({
                    message: "请选择需要复制的试题！",
                    type: "error"
                });
                return;
            } else {
                this.copyDialog = true;
            }
        },
        OpenCopyDialogSingle(index, row) {
            if (!row.SubjectId) {
                this.$message({
                    message: "请选择需要复制的试题！",
                    type: "error"
                });
                return;
            } else {
                this.questionIdstr = row.SubjectId;
                this.copyDialog = true;
            }
        },
        async Copy() {
            try {
                if (this.questionType === null) {
                    this.$message("请选择所属分类")
                    return
                }
                const { data } = await ImportPulicQuestionToOrgan({
                    questionIds: this.questionIdstr,
                    questionType: this.questionType,
                    questionUsed: this.questionUseValue
                });
                if (data.code === 100) {
                    this.$message({
                        message: data.msg,
                        type: "success"
                    });
                    this.$refs.table.clearSelection()
                    this.closeCopyDialog();
                } else {
                    this.$message({
                        message: data.msg,
                        type: "error"
                    });
                }
            } catch (err) {
                this.$message({
                    message: "服务器开小差了",
                    type: "error"
                });
            }
        },
        PageChange(val) {
            this.pageIndex = val;
            this.GetPulicQuestionInfo();
        },
        //
        SizeChange(val) {
            this.pageSize = val;
            this.GetPulicQuestionInfo(true);
        },
        closeCopyDialog() {
            this.questionIdstr = "";
            this.questionType = null;
            this.questionUseValue = 1;
            this.copyDialog = false;
        }
    }
};
</script>

<style lang="less" scoped>
.s-que::v-deep {
    .s-condition {
        padding: 0 30px;
        .item {
            margin-top: 30px;
            .name {
                white-space: nowrap;
                font-size: 16px;
                margin-right: 5px;
            }
        }
        .el-input {
            // width: 300px;
            // height: 34px;
            input {
                height: 34px;
                ::placeholder {
                    font-size: 16px;
                }
            }
        }
        .search {
            .el-button {
                margin-left: -5px;
                width: 90px;
                height: 34px;
                padding: 0;
                border-radius: 4px;
            }
        }
    }
    .s-options {
        padding: 0 30px;
        margin-top: 30px;
        .el-button {
            // width: 90px;
            height: 34px;
            padding: 0 5px;
            border-radius: 4px;
        }
    }
    .el-table {
        margin-top: 20px;
        .options-btn {
            .el-button {
                width: 40px;
                padding: 5px 2px;
            }
        }
    }
    .pagination {
        margin: 20px 0 30px;
    }
}
</style>
